module.exports = __webpack_public_path__ + "img/WS.1aecd25c.svg";